module.exports = __webpack_public_path__ + "media/images/flags/LS-2f685e3214ac78a1351eaec963ae0b65.svg";